<template>
    <div class="col-lg-12">
        <div class="card border-top-0">
            <div class="card-body personal-info">
                <form @submit.prevent="submitForm">
                    <div class="mb-4 d-flex align-items-center justify-content-between">
                        <h5 class="fw-bold mb-0 me-4">
                            <span class="d-block mb-2">İlaç Kartı:</span>
                            <span class="fs-12 fw-normal text-muted text-truncate-1-line">İlaç kartlarını
                                buradan düzenleyebilirsiniz.</span>
                        </h5>
                        <div class="d-flex gap-2">
                            <button type="submit" class="btn btn-lg btn-light-brand bg-green text-white">Kaydet</button>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">İlaç Adı: </label>
                        </div>
                        <div class="col-lg-4">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="medicine.name" placeholder="İlaç Adı">
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <label class="fw-semibold">Barkod: </label>
                        </div>
                        <div class="col-lg-4">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="medicine.barcode" placeholder="Barkod">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">En küçük birim: </label>
                        </div>
                        <div class="col-lg-2">
                            <div class="input-group">
                                <select name="unit" class="form-select form-select-sm" v-model="medicine.unit">
                                    <option v-for="unit in units" :key="unit.value" :value="unit.value">
                                        {{ unit.label }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <label class="fw-semibold">Bu birimdeki doz: </label>
                        </div>
                        <div class="col-lg-2">
                            <div class="input-group">
                                <input type="number" class="form-control" v-model="medicine.dose_per_unit"
                                    placeholder="Doz">
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <label class="fw-semibold">Başlangıç Stok Sayısı: </label>
                        </div>
                        <div class="col-lg-2">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="medicine.initial_quantity"
                                    placeholder="Başlangıç Stok Sayısı">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Etken Madde: </label>
                        </div>
                        <div class="col-lg-2">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="medicine.active_ingredient"
                                    placeholder="Etken Madde">
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <label class="fw-semibold">Kategori: </label>
                        </div>
                        <div class="col-lg-2">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="medicine.category"
                                    placeholder="Kategori">
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <label class="fw-semibold">Kullanım Amacı: </label>
                        </div>
                        <div class="col-lg-2">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="medicine.usage_purpose"
                                    placeholder="Kullanım Amacı">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Saklama Koşulları: </label>
                        </div>
                        <div class="col-lg-4">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="medicine.storage_conditions"
                                    placeholder="Saklama Koşulları">
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <label class="fw-semibold">Açıklama: </label>
                        </div>
                        <div class="col-lg-4">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="medicine.description"
                                    placeholder="Açıklama">
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- Medicine Package Component must be here -->
        <MedicinePackage v-if="medicine.id" :selectedUnitLabel="selectedUnitLabel" :medicine="medicine.id"
            :existing_packages="medicine.medicine_packages" @update:medicinePackages="onPackagesUpdated" />
        <button @click="deneme"> deneme </button>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import MedicinePackage from '@/components/medicine/MedicinePackage.vue';

export default {
    name: 'EditMedicine',
    components: {
        MedicinePackage,
    },
    data() {
        return {
            medicine: {},
            units: [],
            updatedPackages: [],
        }
    },
    async mounted() {
        await this.fetchUnits();
        const medicineId = this.$route.params.id;
        if (medicineId) {
            await this.fetchMedicine(medicineId);
        }
    },
    computed: {
        selectedUnitLabel() {
            const selected = this.units.find(unit => unit.value === this.medicine.unit);
            return selected ? selected.label : 'Seçilmedi';
        }
    },
    methods: {
        deneme() {
            console.log(this.updatedPackages);
        },
        onPackagesUpdated(packages) {
            this.updatedPackages = packages;
            console.log('packages: ', this.updatedPackages);
        },
        async fetchUnits() {
            try {
                const response = await this.$axios.get('medicine_unit_choices/');
                this.units = response.data;
            } catch (error) {
                Swal.fire('Hata', error, 'error');
            }
        },
        async fetchMedicine(id) {
            try {
                const response = await this.$axios.get(`medicine/${id}/`);
                this.medicine = response.data;
            } catch (error) {
                Swal.fire('Hata', error, 'error');
            }
        },
        async submitForm() {
            const transformedPackages = this.updatedPackages.map((pack, index) => {
                console.log('pack: ', pack);
                const parentPack = index > 0 ? this.updatedPackages[index - 1] : null;
                return {
                    id: pack.id || undefined,
                    medicine: this.medicine.id,
                    package_type_display: pack.package_type_display,
                    package_type: pack.package_type,
                    contains_units: parseInt(pack.contains_units),
                    parent: parentPack?.id || null,
                };
            });
            this.medicine.medicine_packages = transformedPackages;
            try {
                console.log('medicine: ', JSON.stringify(this.medicine));
                const response = await this.$axios.put(`medicine/${this.medicine.id}/`, this.medicine);
                Swal.fire('Başarılı', 'İlaç kartı başarıyla güncellendi.', 'success');
                console.log(response);
                this.$router.push({ name: 'Medicines', params: { page: 1 } });

            } catch (error) {
                Swal.fire('Hata', error, 'error');
                console.log(error);
            }
        }
    }
}
</script>